var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 25.6C32 29.1346 29.1346 32 25.6 32H6.4C2.86538 32 0 29.1346 0 25.6V6.4C0 2.86538 2.86538 0 6.4 0H25.6C29.1346 0 32 2.86538 32 6.4V25.6ZM24.9321 6L17.6468 14.4686L25.57 26H19.7425L14.4068 18.2348L7.72649 26H6L13.6403 17.1193L6 6H11.8274L16.8799 13.3532L23.2057 6H24.9321ZM14.508 16.1101L15.2821 17.2173L20.5548 24.7594H23.2066L16.7452 15.5172L15.9711 14.4099L11.0004 7.29968H8.34857L14.508 16.1101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFilled);
export default __webpack_public_path__ + "static/media/twitter_filled.d45fe5fbfde915de1d7101dbf96bbfa6.svg";
export { ForwardRef as ReactComponent };